import { BaseModel } from '../../_base/crud';

export class Affiliation extends BaseModel {
  id: number;
  name: any;
  address_1: any;
  address_2: any;
  city: string;
  state: string;
  zip: string;
  phone: string;
  fax: string;
  email: string;
  affiliation_type_id: number;
  affiliation_type_description: any;
  affiliation_type_name: any;
  description: string;
  location_id: any;
  is_active: boolean;
  note: any;
  tags: any;
  urbanization;
  supervising_control: boolean;
  office_number: any;
  extension: any;
  clear(): void {
    this.id = 0;
    this.name = '';
    this.phone = '';
    this.fax = '';
    this.city = '';
    this.state = '';
    this.email = '';
    this.address_2 = '';
    this.address_1 = '';
    this.zip = '';
    this.affiliation_type_id = null;
    this.description = '';
    this.location_id = '';
    this.supervising_control = false;
    this.office_number = null;
    this.extension = null;
  }
}
